export default "__VITE_ASSET__5bda9056__"